import React, { useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import CustomTextArea from '../../Components/Reusable/CustomTextArea';
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import RoutesPath from "../../Utils/RoutesPath";
import { toast } from "react-toastify";
import AuthorService from "../../Services/AuthorService";

const AddAuthors = () => {
  const [author, setAuthor] = useState();
  const [authorEdit, setAuthorEdit] = useState({ ...useLocation().state });
  const [uploadedDocuments, setUploadedDocuments] = useState(Array());
  const navigate = useNavigate();

  const Validations = yup.object().shape({
    name: validationRegex.required,
    briefIntro: validationRegex.required,
    // instagramLink: validationRegex.instagramLink,
    // twitterLink: validationRegex.twitterLink,
    // youtubeLink: validationRegex.youtubeLink,
    // facebookLink: validationRegex.facebookLink,
    // linkedInLink: validationRegex.linkedInLink,
    // image: validationRegex.required,
  });

  const {
    register,
    handleSubmit,
    setValue: setValues,
    formState: { errors },
    getValues,
    reset,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      name: authorEdit?.name || "",
      briefIntro: authorEdit?.briefIntro || "",
      instagramLink: authorEdit?.instagramLink || "",
      twitterLink: authorEdit?.twitterLink || "",
      youtubeLink: authorEdit?.youtubeLink || "",
      facebookLink: authorEdit?.facebookLink || "",
      linkedInLink: authorEdit?.linkedInLink || "",
      image: authorEdit?.image || "",
    },
  });

  const addAuther = async (author) => {
    try {
      const response = await AuthorService.addAuthors(
        authorEdit?.author_id || "",
        author.name,
        author.briefIntro,
        author.instagramLink,
        author.linkedInLink,
        author.youtubeLink,
        author.facebookLink,
        author.twitterLink,
       uploadedDocuments,
      );
      toast.success(response.message);
      navigate(RoutesPath.authors);
      setAuthorEdit({})
    } catch (error) {
      handleApiErrors(error);
      toast.error("Failed to add auther. Please try again later.");
    }
  };

  useEffect(() => {
    if (authorEdit) {
      setValues("name", authorEdit?.name || "");
      setValues("briefIntro", authorEdit?.briefIntro || "");
      setValues("instagramLink", authorEdit?.instagramLink || "");
      setValues("linkedInLink", authorEdit?.linkedInLink || "");
      setValues("youtubeLink", authorEdit?.youtubeLink || "");
      setValues("facebookLink", authorEdit?.facebookLink || "");
      setValues("twitterLink", authorEdit?.twitterLink || "");
      setValues("image", authorEdit?.image || "");
    
      setUploadedDocuments(authorEdit?.image)
    }
  }, [authorEdit, setValues]);


  const onSubmit = (author) => {
    addAuther(author);
  };
  
  

  return (
    <div>
      <div>
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <h1 className="black fs-18 fw-600 mb-0">AUTHORS</h1>
          <div className="d-flex">
            <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
            <h4 className="fs-12 fw-500 primary mb-0">Authors</h4>
          </div>
        </div>
        <div className="table_container" style={{ display: "block" }}>
          <div className="table_title">
            <div className="table_headings">
              <h1 className="black fs-18 fw-600 mb-0">
                {authorEdit.author_id ? "Edit" : "Add"} Author
              </h1>
            </div>
            <form>
              <div className="row profile_inputs w-100 mt-5">
                <div className="col-md-6">
                  <CustomTextField
                    labelTitle="Name"
                    placeholder="File Name"
                    name="name"
                    id="name"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    showMandatory={true}
                    register={register}
                    setValue={setValues}
                    showError={errors?.name}
                    errorMessage={errors?.name?.message}
                  />
                </div>

                <div className="col-md-6 ">
                  <label className="login_heading">Upload Image</label>
                  <div className="position-relative select_file ">
                    <input
                      type="file"
                      name="image"
                      accept="image/jpeg, image/jpg, image/webp"
                      {...register("image")}
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          const file = e.target.files[0];
                          const validTypes = ["image/jpeg", "image/jpg", "image/webp"];
                          if (!validTypes.includes(file.type)) {
                            toast.error("Only JPG, JPEG, and WEBP files are allowed.");
                            e.target.value = null; // Clear the input value
                          } else {
                            setUploadedDocuments(file);
                          }
                        }
                      }}
                    />

                  </div>
                  <span className="danger fs-14 fw-400 mt-1">(Extension: jpg. jpeg.webp) Note:Dimension Size 1000x600 px</span>                  

                  {authorEdit.image && (
                      <span className="text-success fs-14 fw-400 mt-1">Selected file: {authorEdit.image}</span>
                    )}
                    {errors.image && (
                      <p className="danger fs-14 fw-400 mt-1">{errors.image.message}</p>
                    )}
                </div>
                <CustomTextArea
                  labelTitle="Brief Intro"
                  placeholder="Brief Intro"
                  name="briefIntro"
                  id="briefIntro"
                  inputType={InputType.text}
                  showMandatory={true}
                  additionalClasses="brief"
                  register={register}
                  setValue={setValues}
                  showError={errors?.briefIntro}
                  errorMessage={errors?.briefIntro?.message}
                />
                <div className="col-md-6">
                  <CustomTextField
                    labelTitle="Facebook Link"
                    placeholder="Link"
                    name="facebookLink"
                    id="facebookLink"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    showMandatory={false}
                    register={register}
                    setValue={setValues}
                    showError={errors?.facebookLink}
                    errorMessage={errors?.facebookLink?.message}
                  />
                </div>
                <div className="col-md-6">
                  <CustomTextField
                    labelTitle="Instagram Link"
                    placeholder="Link"
                    name="instagramLink"
                    id="instagramLink"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    showMandatory={false}
                    register={register}
                    setValue={setValues}
                    showError={errors?.instagramLink}
                    errorMessage={errors?.instagramLink?.message}
                  />
                </div>
                <div className="col-md-6">
                  <CustomTextField
                    labelTitle=" LinkedIn Link"

                    placeholder="Link"
                    name="linkedInLink"
                    id="linkedInLink"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    showMandatory={false}
                    register={register}
                    setValue={setValues}
                    showError={errors?.linkedInLink}
                    errorMessage={errors?.linkedInLink?.message}
                  />
                </div>
                <div className="col-md-6">
                  <CustomTextField
                    labelTitle="Youtube Link"
                    placeholder="Link"
                    name="youtubeLink"
                    id="youtubeLink"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    showMandatory={false}
                    register={register}
                    setValue={setValues}
                    showError={errors?.youtubeLink}
                    errorMessage={errors?.youtubeLink?.message}
                  />
                </div>
                <div className="col-md-6">
                  <CustomTextField
                    labelTitle="Twitter Link"
                    placeholder="Link"
                    name="twitterLink"
                    id="twitterLink"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    showMandatory={false}
                    register={register}
                    setValue={setValues}
                    showError={errors?.twitterLink}
                    errorMessage={errors?.twitterLink?.message}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <ButtonWithIcon
                    text={authorEdit?.author_id ? "Update" : "Submit"}
                    icon={SvgImages.tick_mark}
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAuthors;
